module.exports = __webpack_public_path__ + "img/coin-grow.22b21123.png";